export default __webpack_public_path__ + "static/media/ww4.17f09af9.jpg";